<script setup lang="ts">
import { computed } from "vue";

import Button from "~/components/dumb/Button.vue";
import { USER_KIND_CUSTOM } from "~/constants/userKinds";
import { ButtonStyle } from "~/shared/enums";
import type { User } from "~/shared/types";
import { getItemCountText } from "~/utils/common";

const props = defineProps<{
  row: User;
  openWorkflowModal: () => void;
}>();

const isEditable = computed(() => props.row.kind === USER_KIND_CUSTOM);

const workflowCount = computed(() => props.row.workflows?.length ?? 0);

const buttonText = computed(() => {
  if (workflowCount.value === 0) {
    return "Add workflow";
  }
  return getItemCountText(workflowCount.value, "workflow", { noSpecial: true, capitalize: true });
});
</script>

<template>
  <Button
    v-if="isEditable"
    :btn-style="ButtonStyle.SECONDARY"
    :text="buttonText"
    borderless
    disable-hover
    text-style="text-primary-base underline"
    class="!px-0"
    @click="openWorkflowModal" />
</template>
